// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Aufgabe, AufgabeDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateAufgabe(): (
  aufgabeId: string,
  requestBody: AufgabeDaten
) => Promise<Aufgabe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, requestBody) =>
      (await getAPI()).aufgaben.updateAufgabe({ aufgabeId, requestBody }),
    [getAPI]
  );
}
